
class HXFormFieldUrl extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = ''+this.getValue();

            if (!this.getOptional() && value === '') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;

            } else if (value !== '' && hx.isValidUrl(value, this.getAllowedProtocolls()) === false) {
                this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }

            if (alertResult===true) super._validateFieldAlert();

        }
        return this.validationPassed;
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'text');
    }

    /**
     * Wird der Value geaendert, so muss das Url-Oeffnen Icon korrekt gesetzt werden
     * @param {string} value
     */
    setValue(value) {
        super.setValue(value);
        this.enableUrlOpenIcon();
    }

    /**
     * @returns {string}
     */
    getAllowedProtocolls() {
        return this.inputObj.getAttribute('data-hx-allowed-protocols');
    }


    /**
     * Icon aktiv/inaktiv anzeigen, abh. von gueltiger Url im Feld
     * wird intern aufgerufen
     */
    enableUrlOpenIcon() {
        let openIcon = $('.js-url_icon-'+this.inputName+'');
        openIcon.removeClass('hx-icon-form-on').removeClass('hx-icon-form-off');
        if (hx.isValidUrl(this.getValue()+'', this.getAllowedProtocolls()) === true) {
            openIcon.addClass('hx-icon-form-on');
        } else {
            openIcon.addClass('hx-icon-form-off');
        }
    }


    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true) {
            this.enableUrlOpenIcon();

            document.getElementsByClassName('js-url_icon-' + this.inputName)[0].addEventListener("click", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                event.preventDefault();
                if (hx.isValidUrl(this.getValue() + '', this.getAllowedProtocolls()) === true) window.open(this.getValue(), '_blank');
            });

            if (this.getEditable()) {
                this.inputObj.addEventListener("keyup", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                    this.enableUrlOpenIcon();
                });
            }
        }
    }
}




